import { render, staticRenderFns } from "./ECProposalPolicyholder.vue?vue&type=template&id=46ee3e59"
import script from "./ECProposalPolicyholder.vue?vue&type=script&lang=js"
export * from "./ECProposalPolicyholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports